<div class="ag-date-range-filter">
  <app-date-range-selection
    [fromDate]="fromDate"
    [toDate]="toDate"
    [timePresetBar]="true"
    (dateRangeSelection)="onDateRangeSelection($event)"
  ></app-date-range-selection>
  <div class="ag-date-range-filter__footer">
    <div class="ag-date-range-filter__presets">
      <sui-button
        size="sm"
        [variant]="isPresetActive('blank') ? 'primary' : 'secondary'"
        (click)="applyPreset('blank')"
      >
        {{ "ag-date-range-filter.button.blank" | translate }}
      </sui-button>
      <sui-button
        size="sm"
        [variant]="isPresetActive('notBlank') ? 'primary' : 'secondary'"
        (click)="applyPreset('notBlank')"
      >
        {{ "ag-date-range-filter.button.not-blank" | translate }}
      </sui-button>
    </div>
    <sui-button
      class="ag-date-range-filter__cancel"
      size="sm"
      variant="secondary"
      (click)="cancel()"
    >
      {{ "btn.cancel" | translate }}
    </sui-button>
    <sui-button size="sm" variant="secondary" (click)="reset()">
      {{ "ag-date-range-filter.button.reset" | translate }}
    </sui-button>
    <sui-button
      size="sm"
      variant="primary"
      [disabled]="!fromDate || !toDate"
      (click)="apply()"
    >
      {{ "btn.apply" | translate }}
    </sui-button>
  </div>
</div>
